import React from 'react';
export default function WoodenShieldSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 4L6 10V22C6 30 20 36 20 36C20 36 34 30 34 22V10L20 4Z" fill="#8D6E63" />
      <path d="M20 8L10 12V22C10 28 20 32 20 32C20 32 30 28 30 22V12L20 8Z" fill="#A1887F" />
      <path d="M20 14L20 28" stroke="#6D4C41" strokeWidth="2" />
      <path d="M14 20H26" stroke="#6D4C41" strokeWidth="2" />
    </svg>
  );
}
